<template>
    <div class="page-background card-body">
        <div class="row">
            <div class="col-12">
                <div class="background-container">
                    <p class="helpefull">{{ Lang.get('js.profile.required_item') }}</p>
                    <p class="edit-data">{{ Lang.get('js.profile.edit_data') }}</p>
                    <div v-if="!loading">
                        <div class="row item-m-b">
                            <label class="col-3 item-label">{{ Lang.get('js.profile.name') }}:</label>
                            <div class="col-sm-8">
                                <input placeholder="Имя"
                                       name="name"
                                       type="text"
                                       class="form-control"
                                       v-model="form.name"
                                       @input="clearFormErrors('name')">
                                <span
                                        class="text-danger"
                                        v-if="form.errors.has('name')"
                                        v-text="form.errors.get('name')">
                                    </span>
                            </div>
                        </div>
                        <div class="row item-m-b">
                            <label class="col-3 item-label">{{ Lang.get('js.profile.mobile') }}:</label>
                            <div class="col-sm-8">
                                <input placeholder="Телефон"
                                       name="phone"
                                       type="text"
                                       class="form-control mobilephone-input-mask"
                                       v-model="form.phone"
                                       @mouseover="phoneMask"
                                       @input="clearFormErrors('phone')">
                                <span
                                        class="text-danger"
                                        v-if="form.errors.has('phone') "
                                        v-text="Lang.locale == 'ru' ? 'Поле Телефон имеет ошибочный формат' : 'Поле Телефон має хибний формат'">
                                    </span>
                            </div>
                        </div>
                        <div class="row item-m-b">
                            <label class="col-3 item-label">{{ Lang.get('js.profile.email') }}:</label>
                            <div class="col-sm-8">
                                <input placeholder="E-mail"
                                       name="email"
                                       type="text"
                                       class="form-control"
                                       v-model="form.email"
                                       @input="clearFormErrors('email')">
                                <span
                                        class="text-danger"
                                        v-if="form.errors.has('email') "
                                        v-text="form.errors.get('email')">
                                    </span>
                            </div>
                        </div>

                        <div class="row item-m-b">
                            <label class="col-3 item-label">{{ Lang.get('js.profile.your_pass') }}:</label>
                            <div class="col-sm-8">
                                <input :type="showPassword ? 'text' : 'password'"
                                       class="form-control"
                                       name="password"
                                       placeholder="Пароль"
                                       v-model="form.password">
                                <span>{{strongPassword}}</span>
                                <div class="show-pass pass-show" @click="showPass"></div>
                            </div>
                            <span class="text-danger"
                                  v-if="form.errors.has('password')"
                                  v-text="form.errors.get('password')">
                    </span>
                        </div>
                        <div class="row item-m-b">

                            <label class="col-3 item-label">{{ Lang.get('js.profile.your_pass_secondary') }}:</label>
                            <div class="col-sm-8">
                                <input :type="showConfirm ? 'text' : 'password'"
                                       class="form-control"
                                       id="password_confirmation"
                                       name="password_confirmation"
                                       placeholder="Подтверждение пароля"
                                       v-model="form.password_confirmation">
                                <div class="show-pass show-pass-confirmation" @click="showConf"></div>
                                <span v-if="confirmPassword !== ''" v-html="confirmPassword"></span>
                            </div>

                            <span class="text-danger"
                                  v-if="form.errors.has('password_confirmation')"
                                  v-text="form.errors.get('password_confirmation')"></span>
                        </div>
                        <div class="row item-m-b">
                            <div class="col-sm-5">
                                <a :href="urls.user">
                                    <button class="btn my_button type_3"
                                            @click="save" :disabled="isDisabled">
                                        {{ Lang.get('js.profile.button-save') }}
                                    </button>
                                </a>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'user-profile',
        props: {
            urls: {
                required: true,
                type: Object
            },
        },
        data() {
            return {
                form: new Form({
                    id: null,
                    name: '',

                    email: '',
                    phone: '',
                    password: '',
                    password_confirmation: '',
                }),
                item: {},
                loading: true,
                isDisabled: false,
                showPassword: false,
                showConfirm: false,
                confirmPassword: '',
                strongPassword: '',
                Lang,
            }
        },
        methods: {
            clearFormErrors(name) {
                this.form.errors.clear(name);

                if (!this.form.errors.any()) {
                    this.isDisabled = false;
                }
            },
            clearField(fieldName) {
                if (this[fieldName] !== '') {
                    this[fieldName] = '';
                }
            },
            save() {
                this.isDisabled = true;

                this.form.post('/user/{0}/update-profile').then(res => {
                    this.isDisabled = false;
                    this.setData(res);
                        // window.location.replace(res.url);
                        window.location.reload();


                }).catch(rej => console.log(rej));
            },
            getData() {
                this.loading = true;

                axios.post('/user/get-data', {}).then(res => {
                    this.setData(res.data);

                    this.loading = false;
                }).catch(rej => console.log(rej));
            },
            setData(data) {
                this.form.id = data['id'];
                this.form.name = data['name'];

                this.form.email = data['email'];
                this.form.phone = data['phone'];
                 this.form.password ='';
                 this.form.password_confirmation ='';
            },
            phoneMask() {
                helpers.setInputMask('mobilephone');
            },
            showConf() {
                this.showConfirm = !this.showConfirm;
            },
            showPass() {
                this.showPassword = !this.showPassword;
            },
            confirmPass() {
                if (this.form.password_confirmation.length > 0) {
                    if (this.form.password === this.form.password_confirmation) {
                        this.confirmPassword = ' совпадает';
                    } else {
                        this.confirmPassword = ' не совпадает';
                    }
                } else {
                    this.clearField('confirmPassword');
                }
            },
            strongPass: _.debounce(
                function () {
//                    let pass = this.form.password;
//                    if (pass && pass.length >= 8) {
//                        axios({
//                            method: 'post',
//                            url: '/register/strong-password',
//                            data: {pass: pass},
//                            responseType: 'json'
//                        })
//                            .then(response => {
//                                this.strongPassword = response.data.strong;
//                            });
//                    } else {
//                        this.clearField('strongPassword');
//                    }
                }, 500)
        },
        mounted() {
            this.getData();

        },
        watch: {
            'form.password': function () {
                this.strongPass();
                // this.confirmPass();
            },
            'form.password_confirmation': function () {
                this.confirmPass();
                if (this.form.errors.has('password')) {
                    this.form.errors.clear('password');
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/profile/UserProfile.vue